/**
 * @props isBlurred: To show card in disabled or blurred state. (boolean)
 * @props boxCustomStyles: object. style object that allows custom styles to be set on the card container
 * @props boxCheckbox: Object. checkbox attributes for checkbox checked and onChange callback.
 *         sample: boxCheckbox={{
                            showCheckbox: true,
                            isChecked: isChecked,
                            onChangeCb: () => {setIsChecked(prev => !prev)},
                        }}
            if showCheckbox is false, checkbox wont be displayed.
 * @props boxData: Object. Object containing box label and box number.
 */

import React from "react";
import { Card } from "reactstrap";
import Checkbox from "../../checkbox/basecheckbox/Checkbox";
import styles from "./FormBoxesCard.styles";

export default function FormBoxesCard({
    boxCustomStyles = {},
    isBlurred = false,
    boxCheckbox = {},
    boxData = {}
}) {

    const handleCardClick = () => {
        if (boxCheckbox?.showCheckbox && boxCheckbox?.onChangeCb) {
            boxCheckbox.onChangeCb();
        }
    };

    return (
        <>
            <Card>
                <div onClick={handleCardClick} style={{...styles.container, ...(boxCheckbox.isChecked) ? styles.greenBorder : {}, ...(isBlurred) ? styles.blurredBox : {} , ...boxCustomStyles}}>
                    <div style={styles.boxNumberContainer}>
                        <div style={styles.boxNumberTitleNumber}>
                            <div>Box:</div>
                            <div style={styles.boxNumberStyle}>
                                {boxData.boxNumber ?? ""}
                            </div>
                        </div>
                    </div>
                    <div style={styles.labelContainer}>
                        {
                            (boxCheckbox?.showCheckbox) ? <Checkbox checked={boxCheckbox.isChecked} onChangeCb={boxCheckbox.onChangeCb} /> : ""
                        }
                        <div styl={styles.boxLabel}>
                            {boxData.boxLabel ?? ""}
                        </div>
                    </div>
                    
                </div>
            </Card>
        </>
    );
}
